import { z } from "zod";

const allowEmail = ["gmail.com", "outlook.com", "yahoo.com", "aerosimple.in"];

export const registerSchema = z.object({
  name: z.string().min(3, { message: "Name is required" }),
  email: z.coerce
    .string()
    .email({ message: "Email is required" })
    .refine(
      (val) => {
        const emailDomain = val.split("@")[1];
        return allowEmail.includes(emailDomain!);
      },
      {
        message: "Email domain is not allowed or is a disposable email",
      },
    ),
  password: z.string().min(1, { message: "Password is required" }),
  agree: z
    .boolean()
    .refine((val) => val === true, {
      message: "You must agree to the terms and conditions.",
    }),
});

export const loginSchema = z.object({
  email: z.coerce
    .string()
    .email({ message: "Email is required" })
    .refine(
      (val) => {
        const emailDomain = val.split("@")[1];
        return allowEmail.includes(emailDomain!);
      },
      {
        message: "Email domain is not allowed or is a disposable email",
      },
    ),
  password: z.string().min(1, { message: "Password is required" }),
  remember: z.boolean(),
});

export const getUsersIdSchema = z.object({
  id: z.string(),
});

export const getUsersSchema = z.object({
  name: z.string().min(1, { message: "Name is required" }),
  email: z.string().email({ message: "Invalid email address" }),
  phone: z.string().min(1, { message: "Phone is required" }),
  isBanned: z.boolean().default(false).optional(),
});

export const defaultUsersValues = {
  name: "",
  phone: "",
  email: "",
  isBanned: false,
};

export const formUsersFields = [
  {
    type: "multi",
    fields: [
      { name: "name", label: "Name", type: "text", required: true },
      { name: "email", label: "Email", type: "text", required: true },
      { name: "phone", label: "Phone", type: "text", required: true },
      {
        name: "isBanned",
        label: "Banned",
        type: "checkbox",
        required: false,
        description: "The User will be Banned.",
      },
    ],
  },
];

export const getProfileSchema = z.object({
  name: z.string().min(1, { message: "Name is required" }),
  email: z.string().email({ message: "Invalid email address" }),
  phone: z.string().min(1, { message: "Phone is required" }),
});

export const defaultProfileValues = {
  name: "",
  phone: "",
  email: "",
};

export const formProfileFields = [
  {
    type: "single",
    fields: [
      { name: "name", label: "Name", type: "text", required: true },
      { name: "email", label: "Email", type: "text", required: true },
      { name: "phone", label: "Phone", type: "text", required: true },
    ],
  },
];

export type LoginFormValues = z.infer<typeof loginSchema>;
export type SignupFormValues = z.infer<typeof registerSchema>;
